import { render, staticRenderFns } from "./FurniturePanels.vue?vue&type=template&id=0b0b53ab&scoped=true"
import script from "./FurniturePanels.vue?vue&type=script&lang=js"
export * from "./FurniturePanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b53ab",
  null
  
)

export default component.exports